module.exports = __webpack_public_path__ + "ddaed07adfcd2ceda3bab90e0a61feec.gif";